import normalize from "json-api-normalize";
import Attributes from "../../models/Attributes.js";
import Vue from 'vue';

export const PlansApi = {
  getPlans() {
    return Vue.http.get("/api/customers/plans").then(fulfilled => {
      return normalize(fulfilled.body).get(Attributes.plansAttributes);
    })
  },

  getProducts(type) {
    const allowedTypes = ["commercial", "editorial"]
    if (!allowedTypes.includes(type)) {
      throw new Error(`Invalid type ${type} for PlansApi.getProducts`)
    }

    const path = `/api/customers/plans/${type}_products`
    return Vue.http.get(path).then(fulfilled => {
      return normalize(fulfilled.body).get(Attributes.productAttributes);
    })
  },

  getTerms() {
    return Vue.http.get("/api/customers/plans/terms").then(fulfilled => {
      return fulfilled.body.terms
    })
  },

  getApprovedAssets() {
    return Vue.http.get("/api/customers/plans/approved_assets").then(fulfilled => {
      return fulfilled.body.approved_assets
    })
  }
}